import { isAxiosError } from 'axios';

import { DatasetLockError } from './datasetLockError';

export const AGENT_EXECUTION_NOT_FOUND_CODE = 'EXECUTION_NOT_FOUND' as const;

export class AgentExecutionNotFoundError extends Error {
  readonly code = AGENT_EXECUTION_NOT_FOUND_CODE;

  readonly status = 404;

  readonly agentExecutionKey: string;

  constructor(agentExecutionKey: string) {
    super(`Agent execution not found: ${agentExecutionKey}`);
    this.name = 'AgentExecutionNotFoundError';
    this.agentExecutionKey = agentExecutionKey;
  }
}

export function isAgentExecutionNotFoundError(
  error: unknown
): error is AgentExecutionNotFoundError {
  return error instanceof AgentExecutionNotFoundError;
}

function readApiErrorMessage(error: unknown): string | undefined {
  if (!isAxiosError(error)) {
    return undefined;
  }

  const { data } = error.response ?? {};
  if (data && typeof data === 'object' && 'message' in data) {
    const { message } = data as { message: unknown };
    return typeof message === 'string' ? message : undefined;
  }

  return undefined;
}

export function mapAgentLogsApiError(error: unknown): Error {
  if (error instanceof AgentExecutionNotFoundError) {
    return error;
  }

  if (isAxiosError(error)) {
    if (error.response?.status === 409) {
      return new DatasetLockError(readApiErrorMessage(error));
    }

    return new Error(readApiErrorMessage(error) ?? error.message);
  }

  if (error instanceof Error) {
    return error;
  }

  return new Error('Unknown agent logs API error');
}

export {
  DATASET_LOCK_CODE,
  DatasetLockError,
  isDatasetLockError
} from './datasetLockError';
